module.exports = __webpack_public_path__ + "img/supply-empty.c01bedcb.gif";